module.exports = __webpack_public_path__ + "static/media/3D-district-iso.b9fb5343.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/3D-district-iso.jpg
// module id = 139
// module chunks = 0